// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/icons.css
// module id = 1279
// module chunks = 34